import React from 'react';
import { Image } from 'components/media/Image';
import brikkPreviewSrc from 'components/brikks/sustainability/WaterSaving/components/assets/waterSaving-brikk-preview.png';

export const WaterSavingPreview = () => (
  <Image src={brikkPreviewSrc} />
);
